import { CyberSecurityListItem } from "../../../../../models/CybersecurityObject";

interface CybersecurityFiltersOptions {
  company_type?: string[]; // e.g. ["Українська", "Представництво"]
  other_services?: string[]; // e.g. ["Доп послуги кібербезпеки", "Профільна"]
  region?: string[]; // e.g. ["Київ", "Львівська область", ...]
  services?: string[]; // e.g. ["Навчання та підвищення кваліфікації з кібербезпеки", ...]
  company_size?: string[]; // e.g. ["1-10", "11-50", "51-200", "201-500", "501-1000", "1001+"]

  // categories of services provided: boolean
  services_cb: boolean;
  integrators: boolean;
  vendors: boolean;
  distributors: boolean;
  training_cb: boolean;
  association?: boolean;
  government_organization?: boolean;
  ethical_hacking: boolean;
  mssp: boolean;
  audit_consulting: boolean;
  categories: string[]; // e.g. ["Services", "Integrators", ...]
}

export interface ICybersecurityInfoState {
  isObjectsLoading: boolean;
  params: CybersecurityFiltersOptions;
  hash_ids: [];
  selectedObject: CyberSecurityListItem | null;
  count: number;
  next: null | string;
  results: CyberSecurityListItem[];
}

export enum CybersecurityMapActionsEnum {
  SET_IS_CYBERSECURITY_LOADING = "SET_IS_CYBERSECURITY_LOADING",
  SET_MAP_CYBERSECURITY_LIST = "SET_MAP_CYBERSECURITY_LIST",
  SET_SELECTED_CYBERSECURITY_OBJECT = "SET_SELECTED_CYBERSECURITY_OBJECT",
}

export interface SetObjectsLoading {
  type: CybersecurityMapActionsEnum.SET_IS_CYBERSECURITY_LOADING;
  payload: boolean;
}

export interface SetMapCybersecurityAction {
  type: CybersecurityMapActionsEnum.SET_SELECTED_CYBERSECURITY_OBJECT;
  payload: CyberSecurityListItem;
}

export interface SetMapCybersecurityListAction {
  type: CybersecurityMapActionsEnum.SET_MAP_CYBERSECURITY_LIST;
  payload: ICybersecurityInfoState;
}

export type MapObjectAction =
  | SetObjectsLoading
  | SetMapCybersecurityAction
  | SetMapCybersecurityListAction;
